exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._31TYvgEwwDnkRgIbcZtFDP ._2_z_IR5ZdjE9CDLD7Rl8BD{padding:60px 30px;margin:0 0 30px 0;font-weight:bold}._31TYvgEwwDnkRgIbcZtFDP ._2TVQJYdYsAdJgvWeu8Kl40{background:#f5f5f5;padding:20px;margin:0 0 30px 0}\n", ""]);

// Exports
exports.locals = {
	"Widgets": "_31TYvgEwwDnkRgIbcZtFDP",
	"topoInner": "_2_z_IR5ZdjE9CDLD7Rl8BD",
	"demoBox": "_2TVQJYdYsAdJgvWeu8Kl40"
};